import React, { Component } from 'react'
import { Carousel } from 'antd';
import './index.css'
import { observer } from 'mobx-react'
import { observable } from 'mobx';


let inviteCardData = [{
  id: 1,
  title: '高级JAVA开发工程师',
  desc1: '· 负责互联网数据服务产品的设计，代码开发，维护优化等工作',
  desc2: '· 负责APP服务端核心业务处理'
},
{
  id: 2,
  title: '高级前端开发工程师',
  desc1: '· 负责前端产品线的工程化建设和开发规范的制定',
  desc2: '· 负责封装公用组件和优化系统架构',
  desc3: '· 与系统工程师、 设计师密切合作， 参与产品需求、 产品设计， 负责开发实现以及测试、 维护等迭代周期',
}]


@observer
export default class JoinUs extends Component {
  @observable isMore = false

  handleReadMore = () => {
    this.isMore = true
  }
 
  render() {
    return (
      <div id='join'>
        <div className='joinusWrap'>
          <div className='joinusTitle'>加入我们</div>
          <div className='joinusContent'>
             {inviteCardData.map(item => {
              return (
                <div className='regulations' key={item.id}>
                  <div className='title'>
                    {item.title}
                  </div>
                  <div className='intor'>
                    <p>岗位描述</p>
                    <ul className='des_wrap'>
                      <li>{item.desc1}</li>
                      <li>{item.desc2}</li>
                      <li>{item.desc3}</li>
                    </ul>
                  </div>
                </div>
              )
            })}
          </div>
          <div className='p_joinusContent'>
            <Carousel>
              {inviteCardData.map(item => {
              return (
                <div className='regulations' key={item.id}>
                  <div className='title'>
                    {item.title}
                  </div>
                  <div className='intor'>
                    <p>岗位描述</p>
                    <ul className='des_wrap'>
                      <li>{item.desc1}</li>
                      <li>{item.desc2}</li>
                      <li>{item.desc3}</li>
                    </ul>
                  </div>
                </div>
              )
            })}
            </Carousel>
          </div>
          {/* <div className='lookover'>
            查看更多>
          </div>   */}
        </div>
      </div>
    )
  }
}






// WEBPACK FOOTER //
// ./src/app/components/JoinUs/index.js